import { useEffect } from "react";
import { IconArrowRight } from "@tabler/icons-react";
import styles from "./ClientActivitySummary.module.css";
import {
  IconBriefcase,
  IconMessageCircle,
  IconStar,
  IconUsers,
  IconShieldCheck,
  IconAlertTriangle,
  IconAward,
} from "@tabler/icons-react";

const NOTIF_ICON_MAP = {
  IconBriefcase,
  IconMessageCircle,
  IconStar,
  IconUsers,
  IconShieldCheck,
  IconAlertTriangle,
  IconAward,
};
function resolveNotifIcon(name) {
  return NOTIF_ICON_MAP[name] || IconBriefcase;
}

export default function NotificationsFeed({
  notifications,
  onNotificationClick,
  autoMarkAsRead,
}) {
  // useEffect(() => {
  //   notifications
  //     ?.filter((n) => n.isRead && !n.showActionLink)
  //     .forEach((n) => autoMarkAsRead?.(n));
  // }, []);

  return (
    <div>
      <div className={styles.sectionHeader}>
        <span className={styles.sectionTitle}>Notifications</span>
        {/* <a href="/notifications" className={styles.sectionLink}>
          View all <IconArrowRight size={14} />
        </a> */}
      </div>
      <div className={styles.notifFeed}>
        {notifications?.slice(0, 10).map((n) => {
          const Icon = resolveNotifIcon(n?.icon);
          return (
            <div
              key={n?.id}
              className={`${styles.feedItem} ${n?.isRead ? "" : styles.feedItemUnread}`}
            >
              <div className={styles.feedIcon}>
                <Icon size={18} />
              </div>
              <div className={styles.feedBody}>
                <div className={styles.feedTitle}>{n?.title}</div>
                <div className={styles.feedDesc}>{n?.message}</div>
                <div className={styles.feedTime}>{n?.time}</div>
              </div>
              {(n?.isRead || n?.showActionLink) && (
                <div className={styles.feedSide}>
                  {!n?.isRead && (
                    <span className={styles.badgeUnread}>Unread</span>
                  )}
                  {n?.showActionLink && (
                    <span
                      className={styles.feedLink}
                      onClick={() => onNotificationClick?.(n, n?.link)}
                    >
                      View here
                    </span>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
